import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import objectUtil from 'util/ObjectUtil.js';
import _Template from 'properties/main/header.ejs';
import themeService from 'ThemeService.js';
import listService  from 'ListService';
import undoService  from 'UndoService';
import eventBus  from 'EventBus';
import Immutable        from 'immutable';

import factoryService   from 'FactoryService';
import mobileFactoryService from 'mobile/MobileFactoryService';
import textUtil from 'util/TextUtil';

class MainHeaderView extends BasePropertyView {


    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';


        // PF-1803
/*        if (!this.model.get('mainHeaderHeight')) {
            this.model.set('mainHeaderHeight', 20, constants.MODEL_SILENT )
        }*/

        // PF-1961
       if (this.model.get('titleAlign')){
           this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
           this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
           this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);
            switch(this.model.get('titleAlign')){
                case 'left':this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);break;
                case 'center':this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);break;
                case 'right':this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);break;
                default:this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
            }
        }

        this.events = {
            'click img' : 'updateAlignAttributes',
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        let oldPropVal= this.model.get(propName);
        let currentSelected;
        if (listService.selectedCount > 1) {
            currentSelected = Immutable.Map(listService.selected);
            listService.selected.map(view=>{
                this.model = view.model;
                this.model.set('oldPropVal',this.model.get(propName),constants.MODEL_SILENT);
                this.model.set('oldHeight',this.model.get('height'),constants.MODEL_SILENT);
                this.model.set('oldTop',this.model.get('top'),constants.MODEL_SILENT);
                let oldChildTop = this.model.get('childList').reduce((accum,item)=>{
                    let object={};
                    object[item.get('id')] = item.get('top');
                    accum.push(object);
                    return accum;
                },[]);
                this.model.set('oldChildTop',oldChildTop,constants.MODEL_SILENT);

                if(this.model.get('factoryKey') === 'control_group' && propName === 'titleHeight'){
                    let fontFamily = themeService.resolveThemeFont('fontFamily', this.model.get('titleFontFamily'));
                    let height = util.measureTextHeight(this.model.get('titleText'),fontFamily + ',' + this.model.get('titleFontSize') + ',normal,normal',util.extractNum(this.model.get('width')));
                    
                    if(textUtil.isDecimalOrNumeric(propVal)){
                         propVal = parseInt(propVal);
                    }
                    
                    if( Number(propVal) <= Number(height) ){
                        propVal = height;
                    }
                }

                this.model.set( propName, propVal, constants.MODEL_SILENT );
        
                if (propName === 'titleHeight') {
                    this.toggleHeading(this.model.get('hasTitle'));
                }
            });

            if (util.isGroupContainer(this.model.get('factoryKey'))) {
                util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this), 'GroupPropertyChange')
            }
            else {
                this.model.trigger('change');
            }

            undoService.add({
                undo:() =>{
                    let tempPropVal  = oldPropVal;
                    currentSelected.map(view =>{
                        this.model = view.model;
                        this.model.set(propName,this.model.get('oldPropVal'),constants.MODEL_SILENT);
                        this.model.set('height',this.model.get('oldHeight'),constants.MODEL_SILENT);
                        this.model.set('top',this.model.get('oldTop'),constants.MODEL_SILENT);
                        let currentChildList=this.model.get('childList');
                        _.forEach(this.model.get('oldChildTop'),(elemTop)=>{
                            let keyToWork = Object.keys(elemTop)[0];
                            let childToWork=currentChildList.find((child)=>{
                                return child.get('id') === keyToWork;
                            });
                            childToWork.set('top',elemTop[keyToWork],constants.MODEL_SILENT);
                        });

                    });
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,tempPropVal,this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.trigger('change');
                    }
                },
                redo:() =>{
                    currentSelected.map(view => {
                        this.model = view.model;
                        let tempPropVal  = propVal;
                        if(this.model.get('factoryKey') === 'control_group' && propName === 'titleHeight'){
                            let fontFamily = themeService.resolveThemeFont('fontFamily', this.model.get('titleFontFamily'));
                            let height = util.measureTextHeight(this.model.get('titleText'),fontFamily + ',' + this.model.get('titleFontSize') + ',normal,normal',util.extractNum(this.model.get('width')));
                            if( Number(tempPropVal) <= Number(height) ){
                                tempPropVal = height;
                            }
                        }
                        this.model.set( propName, tempPropVal, constants.MODEL_SILENT );

                        if (propName === 'titleHeight') {
                            this.toggleHeading(this.model.get('hasTitle'));
                        }
                    });
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.trigger('change');
                    }
                }
            },textConstants.UNDO_PROP_CHANGE)

        } else {
            const propName = ev.currentTarget.name;
            let propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
            let oldPropVal = this.model.get(propName);
            let oldHeight = this.model.get('height');
            let oldTop = this.model.get('top');
            let oldChildTop = this.model.get('childList').reduce((accum,item)=>{
                let object={};
                object[item.get('id')] = item.get('top');
                accum.push(object);
                return accum;
            },[]);

            if(this.model.get('factoryKey') === 'control_group' && propName === 'titleHeight'){
                let fontFamily = themeService.resolveThemeFont('fontFamily', this.model.get('titleFontFamily'));
                let height = util.measureTextHeight(this.model.get('titleText'),fontFamily + ',' + this.model.get('titleFontSize') + ',normal,normal',util.extractNum(this.model.get('width')));
                
                if(textUtil.isDecimalOrNumeric(propVal)){
                    propVal = parseInt(propVal);
               }
                
                if( Number(propVal) <= Number(height) ){
                    propVal = height;
                }
            }
            if(util.isGroupContainer(this.model.get('factoryKey'))){
                util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
            }
            else {
                this.model.set(propName, propVal);

                if (this.model.get('factoryKey') === 'control_section') {
                    this.model.set('name', propVal);
                    eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'OBJECT', this.model.get('id'));

                    const sectionObject = listService.getSectionById(this.model.get('id')).first();

                    sectionObject.name = propVal;
                    listService.updateMobileSection(sectionObject.id, sectionObject);

                    const selector  = `#objects-page-${listService.currentPageId} ul > li[data-id="${this.model.get('id')}"]`;
                    $(`${selector} > a >span`).contents().first()[0].textContent = propVal;
                    let tooltip = $(`${selector} > a`)[0];
                    let factoryKey = this.model.get('factoryKey');
                    const factoryName = listService.mainKind === constants.KIND_MOBILE ?
                        mobileFactoryService.factories[factoryKey].name : factoryService.factories[factoryKey].name;
                    const tooltipName = factoryName + ': ' + propVal;
                    $(tooltip).prop('title', tooltipName);
                }
            }

            if (propName === 'titleHeight') {
                this.toggleHeading(this.model.get('hasTitle'));
            }

            if (this.model.hasChanged()){
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set(propName, propVal, constants.MODEL_SILENT);
                    this.model.trigger('change');
                }
            }

            undoService.add({
                undo:() => {

                    this.model.set(propName,oldPropVal,constants.MODEL_SILENT);
                    this.model.set('height',oldHeight,constants.MODEL_SILENT);
                    this.model.set('top',oldTop,constants.MODEL_SILENT);
                    let currentChildList=this.model.get('childList');
                    _.forEach(oldChildTop,(elemTop)=>{
                        let keyToWork = Object.keys(elemTop)[0];
                        let childToWork=currentChildList.find((child)=>{
                           return child.get('id') === keyToWork;
                        });
                        childToWork.set('top',elemTop[keyToWork],constants.MODEL_SILENT);
                    });
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        this.render();
                        eventBus.trigger('GroupPropertyChange')
                    }
                    else {
                        this.model.trigger('change');
                    }
                },
                redo:() => {
                    let tempPropVal = propVal;
                    if(this.model.get('factoryKey') === 'control_group' && propName === 'titleHeight'){
                        let fontFamily = themeService.resolveThemeFont('fontFamily', this.model.get('titleFontFamily'));
                        let height = util.measureTextHeight(this.model.get('titleText'),fontFamily + ',' + this.model.get('titleFontSize') + ',normal,normal',util.extractNum(this.model.get('width')));
                        if( Number(tempPropVal) <= Number(height) ){
                            tempPropVal = height;
                        }
                    }
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,tempPropVal,this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.set(propName,tempPropVal);
                    }

                    if (propName === 'titleHeight') {
                        this.toggleHeading(this.model.get('hasTitle'));
                    }

                    if (this.model.hasChanged()){
                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent(propName,tempPropVal,this.model,this.render.bind(this),'GroupPropertyChange');
                        }
                        else {
                            this.model.set(propName, tempPropVal, constants.MODEL_SILENT);
                            this.model.trigger('change');
                        }
                    }
                }
            },textConstants.UNDO_PROP_CHANGE)
        }
    }

    updateAlignAttributes(ev) {

        ev.preventDefault();
        let currentSelected;
        if (listService.selectedCount > 1) {
            currentSelected = Immutable.Map(listService.selected);
            listService.selected.map(view=>{
                this.model = view.model;
                const propName = ev.currentTarget.name;

                let newValue = "left";
                this.model.set('oldAlignLeftSelection',this.model.get('alignLeftSelection',constants.MODEL_SILENT));
                this.model.set('oldAlignCenterSelection',this.model.get('alignCenterSelection',constants.MODEL_SILENT));
                this.model.set('oldAlignRightSelection',this.model.get('alignRightSelection',constants.MODEL_SILENT));

                this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
                this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
                this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);
                if (propName === "align-center") {
                    newValue = "center";
                    this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
                } else if (propName === "align-right") {
                    newValue = "right";
                    this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
                }
                else {
                    this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
                }
                this.model.set('oldTitleAlign',this.model.get('titleAlign'),constants.MODEL_SILENT);
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent('titleAlign',newValue,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set( 'titleAlign', newValue );
                }
            });

            undoService.add({
                undo:() =>{
                    currentSelected.map(view =>{
                       this.model = view.model;

                        this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
                        this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
                        this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);
                            this.model.set('alignCenterSelection', this.model.get('oldAlignCenterSelection'), constants.MODEL_SILENT);
                            this.model.set('alignRightSelection', this.model.get('oldAlignRightSelection'), constants.MODEL_SILENT);
                            this.model.set('alignLeftSelection', this.model.get('oldAlignLeftSelection'), constants.MODEL_SILENT);

                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent('titleAlign',this.model.get('oldTitleAlign'),this.model,this.render.bind(this),'GroupPropertyChange')
                        }
                        else {
                            this.model.set( 'titleAlign', this.model.get('oldTitleAlign') );
                        }
                    });
                },
                redo:() =>{
                    currentSelected.map(view=>{
                        this.model = view.model;
                        const propName = ev.currentTarget.name;

                        let newValue = "left";
                        this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
                        this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
                        this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);
                        if (propName === "align-center") {
                            newValue = "center";
                            this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
                        } else if (propName === "align-right") {
                            newValue = "right";
                            this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
                        }
                        else {
                            this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
                        }
                        if(util.isGroupContainer(this.model.get('factoryKey'))){
                            util.updatePropertyRenderAndSendEvent('titleAlign',newValue,this.model,this.render.bind(this),'GroupPropertyChange')
                        }
                        else {
                            this.model.set( 'titleAlign', newValue );
                        }
                    });
                }
            },textConstants.UNDO_PROP_CHANGE)
        } else {
            const propName = ev.currentTarget.name;
            let newValue = "left";

            this.model.set('oldAlignCenterSelection', this.model.get('alignCenterSelection'), constants.MODEL_SILENT);
            this.model.set('oldAlignLeftSelection', this.model.get('alignLeftSelection'), constants.MODEL_SILENT);
            this.model.set('oldAlignRightSelection', this.model.get('alignRightSelection'), constants.MODEL_SILENT);



            this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
            this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
            this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);
            if (propName === "align-center") {
                newValue = "center";
                this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
            } else if (propName === "align-right") {
                newValue = "right";
                this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
            }
            else {
                this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
            }

            this.model.set('oldTitleAlign',this.model.get('titleAlign'),constants.MODEL_SILENT);

            if(util.isGroupContainer(this.model.get('factoryKey'))){
                util.updatePropertyRenderAndSendEvent('titleAlign',newValue,this.model,this.render.bind(this),'GroupPropertyChange')
            }
            else {
                this.model.set( 'titleAlign', newValue );
            }

            undoService.add({
                undo:() =>{
                    this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
                    this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
                    this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);

                    this.model.set('alignCenterSelection', this.model.get('oldAlignCenterSelection'), constants.MODEL_SILENT);
                    this.model.set('alignRightSelection', this.model.get('oldAlignRightSelection'), constants.MODEL_SILENT);
                    this.model.set('alignLeftSelection', this.model.get('oldAlignLeftSelection'), constants.MODEL_SILENT);

                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent('titleAlign',this.model.get('oldTitleAlign'),this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.set( 'titleAlign', this.model.get('oldTitleAlign') );
                    }
                },
                redo:() =>{
                    this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
                    this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
                    this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);

                    if (propName === "align-center") {
                        newValue = "center";
                        this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
                    } else if (propName === "align-right") {
                        newValue = "right";
                        this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
                    }
                    else {
                        this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
                    }

                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent('titleAlign',newValue,this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.set( 'titleAlign', newValue );
                    }
                }
            },textConstants.UNDO_PROP_CHANGE)
        }
    }

    //=============================================================================================
    // PF-1803
    // If now checked -- show the header
    //  1. Increase group height by header height
    //  2. Decrease  top origin by header height
    //  3. Increase each child's top origin by header height
    // else -- remove the header
    //  1. Decrease group height by header height
    //  2. Increase each child's top origin by header height
    //  3. Decrease top origin by header height

    // After either operation, adjust if group would exceed page top, bottom, or both
    // If group would exceed the top, move if down by header height
    // If group would exceed the bottom, shrink its height to not exceed the bottom.
    //=============================================================================================
    updateCheckAttributes( ev ) {
        ev.preventDefault();
        ev.stopPropagation();

        let currentSelected;
        let oldPropVal=this.model.get(ev.currentTarget.name);
        if (listService.selectedCount > 1) {
            currentSelected = Immutable.Map(listService.selected);
            listService.selected.map((view)=>{
                this.model = view.model;
                this.model.set(ev.currentTarget.name, ev.currentTarget.checked, {silent: true});
                this.toggleHeading(ev.currentTarget.checked);
            });
            undoService.add({
                undo:()=>{
                    currentSelected.map(view=>{
                        this.model= view.model;
                        this.model.set(ev.currentTarget.name, util.isTrue(oldPropVal), {silent: true});
                        this.toggleHeading(util.isTrue(oldPropVal));
                    })
                },
                redo:()=>{
                    currentSelected.map(view=>{
                        this.model= view.model;
                        this.model.set(ev.currentTarget.name, ev.currentTarget.checked, {silent: true});
                        this.toggleHeading(ev.currentTarget.checked);
                    })
                }
            }, textConstants.UNDO_PROP_CHANGE);

        } else {
            this.model.set(ev.currentTarget.name, ev.currentTarget.checked, {silent: this.model.get('factoryKey') !== 'control_section'});
            this.toggleHeading(ev.currentTarget.checked);
            undoService.add({
                undo:()=>{
                        this.model.set(ev.currentTarget.name, util.isTrue(oldPropVal), {silent: true});
                        this.toggleHeading(util.isTrue(oldPropVal));
                },
                redo:()=>{
                        this.model.set(ev.currentTarget.name, ev.currentTarget.checked, {silent: true});
                        this.toggleHeading(ev.currentTarget.checked);
                }
            },textConstants.UNDO_PROP_CHANGE)
        }
    }


        // Common model manipulation for checked or unchecked
    toggleHeading( isChecked ) {

        const
            sign = isChecked ? 1 : -1,
            signedDelta = sign * util.extractNum(this.model.get('titleHeight')),
            grpHeight = util.extractNum(this.model.get('height')) + signedDelta;

        this.model.set('top', util.extractNum(this.model.get('top')) - signedDelta, constants.MODEL_SILENT);
        this.model.set('height', grpHeight, constants.MODEL_SILENT);

        // Base logic mostly finished at ths point.
        // Checks for page boundary violation, child movement, and sync follow:

        // Check 1. If top negative. That means header would cut through the page top;
        if (util.extractNum(this.model.get('top')) <= 0) {
            // Move group down so top is at 1px
            this.model.set('top', 1, constants.MODEL_SILENT);
        }

        // Check 2. If model is checked and if group bottom will exceed page bottom, shrink the group by the excess
        // (happens if headerless group height within mainHederHeight of page height)
        const
            pgBottom = 0 + $(constants.PAGESEL_ID).height(),
            grpBottom = util.extractNum(this.model.get('top')) + util.extractNum(this.model.get('height')),
            excess = grpBottom - pgBottom;

        if (isChecked && excess >= 0) {
            // Shrink group height by excess minus one
            this.model.set('height', (grpBottom - excess - 1), constants.MODEL_SILENT);
        }

        // Move model childList items vertically by signedDelta
        function relocateKids( signedDelta, model ){
            if ( signedDelta ) {
                _.forEach( model.get('childList'), childModel => {
                    const newTop = util.extractNum(childModel.get('top')) + signedDelta;
                    childModel.set('top', newTop, constants.MODEL_SILENT);
                });
            }
        }
        

        // Any fixups finished. So ....
        // adjust children vertically, and reflect model to the UI.
        relocateKids(signedDelta, this.model);

        if (this.model.hasChanged()){
            if(util.isGroupContainer(this.model.get('factoryKey'))){
                eventBus.trigger('GroupPropertyChange')
                this.render();
            }
            else {
                this.model.trigger('change');
            }
        }
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const hasTitle = util.isTrue(this.model.get('hasTitle'));
        $(`input[name='hasTitle']`).prop('checked', hasTitle );

        this.addMultilanguageIcon();
        
        this.delegateEvents();
        return this;
    }

}

export default MainHeaderView;
